export default "__VITE_ASSET__2d62c193__"